import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Modal, Button, Form, Alert, Spinner } from "react-bootstrap";
import { useTable, usePagination } from "react-table";
import "./asistencia.css";

import { FaEdit } from "react-icons/fa";
import { BsPersonLinesFill } from "react-icons/bs";

function ExcusasListModal({ show, handleClose, excusas, handleDeleteExcusa }) {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Lista de Excusas</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {excusas.length > 0 ? (
          <ul style={{ "list-style": "none" }}>
            {excusas.map((excusa) => (
              <li key={excusa.id}>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleDeleteExcusa(excusa.id)}
                  className="delete-excusa"
                >
                  x
                </Button>{" "}
                <strong>{excusa.maestra_nombre.nombre}:</strong>{" "}
                {excusa.excusa_texto}
              </li>
            ))}
          </ul>
        ) : (
          <p>No hay excusas registradas para esta asistencia.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

function ExcusaModal({
  showExcusaModal,
  handleClose,
  selectedExcusaAsistencia,
  maestras,
  excusaText,
  setExcusaText,
  selectedMaestra,
  setSelectedMaestra,
  handleExcusaSubmit,
}) {
  return (
    <Modal show={showExcusaModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Registrar Excusa</Modal.Title>
      </Modal.Header>
      <Modal.Body className="asistencia-modal-excusa">
        {selectedExcusaAsistencia && (
          <>
            <h6>
              {selectedExcusaAsistencia.curso_nombre.comuna} -{" "}
              {selectedExcusaAsistencia.curso_nombre.nombre}
            </h6>
            <p>Fecha: {selectedExcusaAsistencia.fecha_formateada}</p>
            <Form.Group>
              <Form.Label>Seleccionar Maestra</Form.Label>
              <Form.Control
                as="select"
                value={selectedMaestra}
                onChange={(e) => setSelectedMaestra(e.target.value)}
              >
                <option value="">Seleccionar Maestra</option>
                {maestras.map((maestra) => (
                  <option key={maestra.rut} value={maestra.rut}>
                    {maestra.nombre}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group>
              <Form.Label>Justificación Inasistencia:</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={excusaText}
                onChange={(e) => setExcusaText(e.target.value)}
              />
            </Form.Group>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={handleExcusaSubmit}
          disabled={!selectedMaestra}
        >
          Enviar Excusa
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

function ComunaTable({
  comuna,
  asistencias,
  columns,
  handleEditClick,
  handleExcusaClick,
}) {
  const data = useMemo(() => asistencias, [asistencias]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    usePagination,
  );

  return (
    <div key={comuna}>
      <h4>{comuna}</h4>
      <table {...getTableProps()} className="asistencia-table">
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="pagination">
        <select
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
          }}
        >
          {[10, 20, 30, 40, 50].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
        <span>
          Page{" "}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{" "}
        </span>
        <Button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {"<<"}
        </Button>
        <Button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {"<"}
        </Button>
        <Button onClick={() => nextPage()} disabled={!canNextPage}>
          {">"}
        </Button>
        <Button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {">>"}
        </Button>
      </div>
    </div>
  );
}

function Asistencia() {
  const [cursos, setCursos] = useState([]);
  const [asistencias, setAsistencias] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showEditSuccessAlert, setShowEditSuccessAlert] = useState(false);
  const [showExcusaModal, setShowExcusaModal] = useState(false);
  const [showExcusasListModal, setShowExcusasListModal] = useState(false);
  const [selectedExcusaAsistencia, setSelectedExcusaAsistencia] =
    useState(null);
  const [excusas, setExcusas] = useState([]); // State to hold the fetched excusas
  const [excusaText, setExcusaText] = useState("");
  const [selectedMaestra, setSelectedMaestra] = useState("");
  const [selectedCurso, setSelectedCurso] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedAsistencia, setSelectedAsistencia] = useState(null);
  const [selectedEditMaestras, setSelectedEditMaestras] = useState([]);

  useEffect(() => {
    fetchCursos();
    // Only fetch asistencias if a course is selected
    if (selectedCurso) {
      fetchAsistencias(selectedCurso);
    }
  }, [selectedCurso]); // Add `selectedCurso` as a dependency

  const fetchCursos = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API}api/perfiles/cursos_activos/`,
      );
      const data = await response.json();
      setCursos(data);
    } catch (error) {
      console.error("Error fetching cursos:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAsistencias = async (cursoId) => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API}api/asistencia/asistencias/?curso=${cursoId}`,
      );
      const data = await response.json();
      setAsistencias(data);
    } catch (error) {
      console.error("Error fetching asistencias:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchExcusas = async (asistenciaId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API}api/asistencia/excusas/?asistencia=${asistenciaId}`,
      );
      const data = await response.json();
      setExcusas(data);
      setShowExcusasListModal(true);
    } catch (error) {
      console.error("Error fetching excusas:", error);
    } finally {
    }
  };

  const fetchCSRFToken = async () => {
    const apiUrlcsrf = `${process.env.REACT_APP_BASE_API}api/csrf_token/`;
    const response = await fetch(apiUrlcsrf, { credentials: "include" });
    const data = await response.json();
    return data.csrfToken;
  };

  const handleDeleteExcusa = async (excusaId) => {
    setIsLoading(true);
    const csrfToken = await fetchCSRFToken();
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API}api/asistencia/excusas/${excusaId}/`,
        {
          method: "DELETE",
          headers: {
            "X-CSRFToken": csrfToken,
          },
          credentials: "include",
        },
      );
      if (response.ok) {
        setExcusas(excusas.filter((excusa) => excusa.id !== excusaId)); // Remove deleted excusa from the state
        setShowEditSuccessAlert(true);
        setTimeout(() => setShowEditSuccessAlert(false), 5000);
      }
    } catch (error) {
      console.error("Error deleting excusa:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExcusaClick = useCallback(
    (asistenciaId) => {
      const asistencia = asistencias.find(
        (asistencia) => asistencia.id === asistenciaId,
      );
      setSelectedExcusaAsistencia(asistencia);
      setSelectedMaestra("");
      setShowExcusaModal(true);
    },
    [asistencias],
  ); // Add dependencies here as needed

  const columns = useMemo(
    () => [
      {
        Header: "Fecha",
        accessor: "fecha_formateada",
      },
      {
        Header: "Curso",
        accessor: "curso_nombre",
        Cell: ({ value }) => `${value.comuna} - ${value.nombre}`,
      },
      {
        Header: "Acciones",
        Cell: ({ row }) => (
          <div className="asistencia-actions">
            <Button
              variant="secondary"
              onClick={() => handleEditClick(row.original.id)}
            >
              <FaEdit /> Edit
            </Button>{" "}
            <Button
              variant="warning"
              onClick={() => handleExcusaClick(row.original.id)}
            >
              <strong>Excusa</strong>
            </Button>{" "}
            <Button
              variant="primary"
              onClick={() => fetchExcusas(row.original.id)} // Fetch excusas and open modal
            >
              <BsPersonLinesFill /> Ex
            </Button>
          </div>
        ),
      },
    ],
    [handleExcusaClick], // Dependency array now safely includes handleExcusaClick
  );

  const groupByComuna = (asistencias) => {
    return asistencias.reduce((groups, asistencia) => {
      const comuna = asistencia.curso_nombre.comuna;
      if (!groups[comuna]) {
        groups[comuna] = [];
      }
      groups[comuna].push(asistencia);
      return groups;
    }, {});
  };

  const groupedAsistencias = useMemo(
    () => groupByComuna(asistencias),
    [asistencias],
  );

  const handleEditClick = async (id) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API}api/asistencia/asistencias/${id}/`,
      );
      const data = await response.json();
      setSelectedAsistencia(data);
      setSelectedEditMaestras(
        data.maestras_asistentes_nombre.map((maestra) => maestra.rut),
      );
      setShowEditModal(true);
    } catch (error) {
      console.error("Error fetching asistencia:", error);
    } finally {
    }
  };

  const handleExcusaSubmit = async () => {
    if (!selectedExcusaAsistencia || !selectedMaestra) return;

    setIsLoading(true);
    const csrfToken = await fetchCSRFToken();
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API}api/asistencia/excusas/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrfToken,
          },
          body: JSON.stringify({
            asistencia: selectedExcusaAsistencia.id,
            maestra: selectedMaestra,
            excusa_texto: excusaText,
          }),
          credentials: "include",
        },
      );
      if (response.ok) {
        setShowExcusaModal(false);
        setExcusaText("");
        setSelectedMaestra("");
        setShowEditSuccessAlert(true);
        setTimeout(() => setShowEditSuccessAlert(false), 5000);
      }
    } catch (error) {
      console.error("Error submitting excusa:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditSubmit = async () => {
    setIsLoading(true);
    const csrfToken = await fetchCSRFToken();
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API}api/asistencia/asistencias/${selectedAsistencia.id}/`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrfToken,
          },
          body: JSON.stringify({
            curso: selectedAsistencia.curso,
            fecha: selectedAsistencia.fecha,
            maestras_asistentes: selectedEditMaestras,
          }),
          credentials: "include",
        },
      );
      const updatedAsistencia = await response.json();
      setAsistencias(
        asistencias.map((asistencia) =>
          asistencia.id === updatedAsistencia.id
            ? updatedAsistencia
            : asistencia,
        ),
      );
      setShowEditModal(false);
      setShowEditSuccessAlert(true);
      setTimeout(() => setShowEditSuccessAlert(false), 5000);
    } catch (error) {
      console.error("Error updating asistencia:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditMaestraSelection = (maestraId) => {
    setSelectedEditMaestras((prevSelected) =>
      prevSelected.includes(maestraId)
        ? prevSelected.filter((rut) => rut !== maestraId)
        : [...prevSelected, maestraId],
    );
  };

  const handleCursoChange = (e) => {
    const selectedId = e.target.value;
    setSelectedCurso(selectedId);
    if (selectedId) {
      fetchAsistencias(selectedId);
    } else {
      setAsistencias([]);
    }
  };

  return (
    <div className="capsule">
      <h3>Listado de Asistencias</h3>
      <div id="asistencia-formulario">
        <label>Seleccionar Curso:</label>
        <select value={selectedCurso || ""} onChange={handleCursoChange}>
          <option value="">Seleccione un curso</option>
          {cursos.map((curso) => (
            <option key={curso.id} value={curso.id}>
              {curso.comuna} - {curso.nombre}
            </option>
          ))}
        </select>
      </div>
      {isLoading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100px" }}
        >
          <Spinner animation="border" role="status" />
        </div>
      ) : (
        <div id="asistencia">
          {showEditSuccessAlert && (
            <Alert variant="success">Asistencia editada exitosamente.</Alert>
          )}
          <hr />
          {Object.entries(groupedAsistencias).map(([comuna, asistencias]) => (
            <>
              <div className="asistencia-table">
                <ComunaTable
                  key={comuna}
                  comuna={comuna}
                  asistencias={asistencias}
                  columns={columns}
                  handleEditClick={handleEditClick}
                  handleExcusaClick={handleExcusaClick}
                />
              </div>
              <hr />
            </>
          ))}

          <ExcusaModal
            showExcusaModal={showExcusaModal}
            handleClose={() => setShowExcusaModal(false)}
            selectedExcusaAsistencia={selectedExcusaAsistencia}
            maestras={
              selectedExcusaAsistencia
                ? selectedExcusaAsistencia.maestras_inasistentes_nombre
                : []
            }
            excusaText={excusaText}
            setExcusaText={setExcusaText}
            selectedMaestra={selectedMaestra}
            setSelectedMaestra={setSelectedMaestra}
            handleExcusaSubmit={handleExcusaSubmit}
          />

          <ExcusasListModal
            show={showExcusasListModal}
            handleClose={() => setShowExcusasListModal(false)}
            excusas={excusas}
            handleDeleteExcusa={handleDeleteExcusa}
          />

          <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Editar Maestras Asistentes</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {selectedAsistencia &&
                cursos
                  .find(
                    (curso) => curso.id === selectedAsistencia.curso_nombre.id,
                  )
                  ?.elegidas.map((maestra) => (
                    <div className="mini-modal" key={maestra.rut}>
                      <Form.Check
                        type="checkbox"
                        label={maestra.nombre}
                        checked={selectedEditMaestras.includes(maestra.rut)}
                        onChange={() => handleEditMaestraSelection(maestra.rut)}
                      />
                      <img
                        className="mini-icon"
                        src={
                          maestra.imagen ||
                          "https://cdn-redmaestra-endpoint.azureedge.net/static/images/default.png"
                        }
                        alt={maestra.nombre}
                      />
                    </div>
                  ))}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" onClick={handleEditSubmit}>
                Guardar Cambios
              </Button>
              <Button
                variant="secondary"
                onClick={() => setShowEditModal(false)}
              >
                Cerrar
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      )}
    </div>
  );
}

export default Asistencia;
